import type { UserProfileJSONObject } from '@ikegps/core-api';
import { ModalFormComponent } from '../../components/modal.form/modal.form.component';
import { T, Translate } from '../../i18n/index';
import type { AccountsCtrl } from './accounts.ctrl';

const ACCOUNTS_REMOVE_SUCCESS = { key: T.ACCOUNTS_REMOVE_SUCCESS };

export class AccountsConfirmRemove extends ModalFormComponent {
	ctrl: AccountsCtrl;
	user: UserProfileJSONObject;

	constructor(ctrl: AccountsCtrl, user: UserProfileJSONObject) {
		super({
			title: T.ACCOUNTS_REMOVE_TITLE,
			confirm: T.ACCOUNTS_REMOVE,
			success: ACCOUNTS_REMOVE_SUCCESS,
		});

		this.ctrl = ctrl;
		this.user = user;
	}

	get nodes() {
		return Translate(T.ACCOUNTS_REMOVE_CONFIRM, this.user.username) as any;
	}

	override submit(): Promise<boolean> {
		return this.ctrl.removeUser(this.user);
	}

	override failToChange() {
		this.ctrl.setLoading(this.user.objectId, false);
	}
}
